import { createContext } from 'react';

export const StickerContext = createContext(null);